import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const CharacterSelectionContainerViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    margin-bottom: 20px;
    h1 {
      font-size: 18px;
    }
    h4 {
      font-size: 22px;
      margin: 0 auto;
    }
    P {
      font-size: 14px;
      margin: 10px auto;
      width: 268px;
      text-align: center;
    }
    .characters-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 334px;
      height: 276px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15);
      overflow-x: auto;
    }
    .selection {
      width: 110px;
      height: 48px;
      border: 0;
      font-size: 16px;
      cursor: pointer;
      margin-top: 5px;
      margin-bottom: 1%;
    }
    img {
      width: 150px;
    }
  `,
  tablet: css`
    & > div {
      display: flex;
      justify-content: space-between;
      margin-top: 5%;
    }
    .characters-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(100% / 3);
      height: 336px;
      margin-right: 5px;
      background: #ffffff;
      box-shadow: 0px 0px 12px rgb(0 0 0 / 15%);
    }
    img {
      width: 150px;
      margin-top: 10%;
    }

    P {
      font-size: 14px;
      padding: 4px 13px;
      height: 72px;
    }
    button {
      width: 110px;
      height: 48px;
      border: 0;
      font-size: 16px;
      cursor: pointer;
      margin-top: 30px;
      margin-bottom: 5%;
    }
    h4 {
      margin: auto;
    }
  `,
  tabletLandscape: css`
    & > div {
      display: flex;
      justify-content: space-between;
      margin-top: 5%;
    }
    .characters-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(100% / 3);
      height: 336px;
      margin-right: 5px;
      background: #ffffff;
      box-shadow: 0px 0px 12px rgb(0 0 0 / 15%);
    }
    h1 {
      font-size: 36px;
    }
    img {
      width: 150px;
      margin-top: 10%;
    }

    P {
      font-size: 14px;
      padding: 4px 13px;
      height: 72px;
    }
    button {
      width: 110px;
      height: 48px;
      border: 0;
      font-size: 16px;
      cursor: pointer;
      margin-top: 30px;
      margin-bottom: 5%;
    }
    h4 {
      margin: auto;
    }
  `,

  browser: css`
    & > div {
      display: flex;
      justify-content: space-between;
      margin-top: 5%;
    }
    .characters-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(100% / 3);
      /* height: 336px; */
      height: auto;
      margin-right: 5px;
      background: #ffffff;
      box-shadow: 0px 0px 12px rgb(0 0 0 / 15%);
    }
    img {
      width: 150px;
      margin-top: 10%;
    }

    P {
      font-size: 14px;
      padding: 4px 13px;
      /* height: 72px; */
    }
    button {
      width: 110px;
      height: 48px;
      border: 0;
      font-size: 16px;
      cursor: pointer;
      margin-top: 30px;
      margin-bottom: 5%;
    }
    h4 {
      margin: auto;
    }
  `,
};

export const CharacterSelectionContainer = styled.div`
  margin-top: auto;
  margin-bottom: 40px;
  h1 {
    color: ${({ theme }) => theme.colors.nrmaBlue};
    text-align: center;
    font-size: 36px;
  }
  h4 {
    margin: auto;
    color: ${({ theme }) => theme.colors.nrmaBlue};
  }
  .selection {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.nrmaBlue};
  }

  .react-multi-carousel-dot > button {
    height: 20px;
    width: 20px;
    background-color: #c4c4c4;
  }
  .react-multi-carousel-dot--active > button {
    background-color: ${({ theme }) => theme.colors.nrmaBlue};
  }

  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return CharacterSelectionContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? CharacterSelectionContainerViews["tabletLandscape"]
          : CharacterSelectionContainerViews["tablet"];

      case "browser":
        return CharacterSelectionContainerViews["browser"];
    }
  }}
`;
